import { StateService } from '@uirouter/angular';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DiffContextService } from '../diff-context.service';
import { UiService } from '../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';
import * as _ from 'lodash';

@Component({
  selector: 'comment-form',
  template: require('./comment-form.component.html')
})
export class CommentFormComponent implements OnInit {
  line: any = null;
  @Input() commit: any;
  @Input() diff: any;
  @Input() idx: number;

  commentBody: string;

  constructor(
    private http: HttpClient,
    private diffContextService: DiffContextService,
    private uiService: UiService,
    private stateService: StateService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit(): void {
    this.commentBody = '';
  }

  saveComment(): void {
    const lastLine = _.get(this.diff.lines, `[${this.idx}]`, 0);
    const commitHash = _.get(
      _.last(this.commit.rel.commits),
      'commitHash',
      false
    );

    if (!lastLine || !commitHash) {
      this.uiService.message.showWarning(
        this.translateService.translate('No diff or commit was selected')
      );
    }

    const comment = {
      path: _.get(this.diff, 'fileName', ''),
      line: this.diffContextService.getCommitLine(lastLine),
      body: _.trim(this.commentBody),
      context: this.diffContextService.getContextLines(this.diff, this.idx),
      commit: commitHash,
    };

    if (!comment.body?.length) {
      this.uiService.message.showWarning(
        this.translateService.translate('Please enter a message first')
      );
      return;
    }

    const url = `/api/scm/${this.stateService.params.unixName}/comment`;

    this.http
      .post(url, comment)
      .subscribe(
        (result) => {
          lastLine.comments.push(result);
          this.commit.rel.comments.push(result);
          this.commentBody = '';
        },
        (error) => {
          this.uiService.message.showError(
            this.translateService.translate('Sorry, could not post your comment.')
          );
        }
      );
  }
}
